<div class="spinner-center" *ngIf="loading">
    <mat-spinner></mat-spinner>
</div>
<div class="registers-div" *ngIf="!loading">
    <div class="ml10">
        <button *ngIf="!disabled" mat-raised-button color="primary" (click)="assignRegister()"
            [matTooltip]="'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.STEPS.REGISTERS.NEW_ITEM' | translate">
            <mat-icon>add</mat-icon>
        </button>
    </div>
    
    <form [formGroup]="group" [ngClass]="!disabled ? 'w95' : 'w100'" *ngIf="formArray.controls.length > 0">
        <div [formArrayName]="controlName">
            <mat-accordion>
                <div class="accordion-div" *ngFor="let control of formArray.controls; let i = index"
                    [formGroupName]="i">
                    <mat-expansion-panel #panel class="expansion-panel"
                        [expanded]="i === formArray.controls.length-1 && formArray.controls.length === 1">
                        <mat-expansion-panel-header>
                            <mat-panel-title>{{control.get('name').value}}</mat-panel-title>
                            <mat-panel-description>
                                <mat-icon>dvr</mat-icon>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <div class="div-wrap">
                            <smt-search-select [useChips] = "false" [group]="formArrayGroup(i)" [controlName]="'category'"
                                [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.MAIN_DATA.CATEGORY'"
                                [disabled]="true"></smt-search-select>

                            <smt-search-select [useChips] = "false" [group]="formArrayGroup(i)" [controlName]="'typology'"
                                [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.MAIN_DATA.TYPOLOGY'"
                                [disabled]="true"></smt-search-select>

                            <smt-search-select [useChips] = "false" [group]="formArrayGroup(i)" [controlName]="'title'"
                                [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.MAIN_DATA.TITLE'"
                                [disabled]="true"></smt-search-select>

                            <div class="w45">
                                <smt-search-select [useChips] = "false" [group]="formArrayGroup(i)" [controlName]="'depositProv'"
                                    [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.MAIN_DATA.PROVISIONAL_DEPOSIT'"
                                    [disabled]="true"></smt-search-select>
                            </div>

                            <div class="w45">
                                <smt-search-select [useChips] = "false" [group]="formArrayGroup(i)" [controlName]="'descLevel'"
                                    [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.MAIN_DATA.LEVEL_DESCRIPTION'"
                                    [disabled]="true"></smt-search-select>
                            </div>

                            <div class="w45">
                                <smt-date-input [group]="formArrayGroup(i)" [controlName]="'startDate'"
                                    [extraControlName]="'endDate'" [dateType]="DateType.RANGE"
                                    [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.MAIN_DATA.DATE'"
                                    [placeholder]="'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.MAIN_DATA.START_DATE'"
                                    [extraPlaceholder]="'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.MAIN_DATA.END_DATE'"></smt-date-input>
                            </div>

                            <mat-form-field class="w45">
                                <mat-label>
                                    {{ 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.MAIN_DATA.VOLUME_SUPPORT' | translate
                                    }}</mat-label>
                                <textarea matInput cdkTextareaAutosize formControlName="supportVolume"></textarea>
                            </mat-form-field>
                        </div>

                        <div class="action-buttons" *ngIf="control.get('id').value as id">                        
                            <button *ngIf="isManager && loanStatus !== UDEU_LOAN_IN_PROGRESS_STATUS" mat-raised-button color="primary" (click)="printReceipt(id)"
                                [matTooltip]="'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.STEPS.REGISTERS.PRINT_RECEIPT_EXT' | translate">
                                <mat-icon>picture_as_pdf</mat-icon> {{ 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.STEPS.REGISTERS.PRINT_RECEIPT' | translate }}
                            </button>
                            <button mat-raised-button color="primary" (click)="viewReg(id)" *ngIf="canViewRecord"
                                [matTooltip]="'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.STEPS.REGISTERS.VIEW_ITEM' | translate">
                                <mat-icon>visibility</mat-icon> {{ 'APP.ACTIONS.VIEW' | translate }}
                            </button>
                            <button mat-raised-button color="warn" (click)="delete(control, i)" *ngIf="!disabled"
                                [matTooltip]="'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.STEPS.REGISTERS.DELETE_ITEM_EXT' | translate">
                                <mat-icon>delete</mat-icon> {{ 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.STEPS.REGISTERS.DELETE_ITEM' | translate }}
                            </button>
                        </div>
                    </mat-expansion-panel>
                </div>
            </mat-accordion>
        </div>
    </form>

    <mat-card *ngIf="formArray.controls.length == 0" class="center">
        <mat-card-content>
            {{ 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.STEPS.REGISTERS.EMPTY_ITEM' | translate }}
        </mat-card-content>
    </mat-card>
</div>